/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x3100=['TrackChangesEditing','get','MentionEditing','plugins','afterInit','has','enableCommand','mention'];(function(_0x2f0dd4,_0x31007c){const _0x4d5bb2=function(_0x55398d){while(--_0x55398d){_0x2f0dd4['push'](_0x2f0dd4['shift']());}};_0x4d5bb2(++_0x31007c);}(_0x3100,0x129));const _0x4d5b=function(_0x2f0dd4,_0x31007c){_0x2f0dd4=_0x2f0dd4-0x0;let _0x4d5bb2=_0x3100[_0x2f0dd4];return _0x4d5bb2;};import{Plugin as _0x571e4e}from'ckeditor5/src/core';export default class et extends _0x571e4e{[_0x4d5b('0x3')](){const _0x5d163e=this['editor'];_0x5d163e[_0x4d5b('0x2')][_0x4d5b('0x4')](_0x4d5b('0x1'))&&_0x5d163e[_0x4d5b('0x2')][_0x4d5b('0x0')](_0x4d5b('0x7'))[_0x4d5b('0x5')](_0x4d5b('0x6'));}}